import { render, staticRenderFns } from "./associaterecordpicker.vue?vue&type=template&id=56422e74&"
import script from "./associaterecordpicker.vue?vue&type=script&lang=js&"
export * from "./associaterecordpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports